module.exports = __webpack_public_path__ + "static/media/monalisa-7.8564a63a.jpg";